"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RollupUserLogic__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "sendRoot",
                type: "bytes32",
            },
        ],
        name: "NodeConfirmed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "parentNodeHash",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "nodeHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "executionHash",
                type: "bytes32",
            },
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                indexed: false,
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "afterInboxBatchAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "wasmModuleRoot",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "inboxMaxCount",
                type: "uint256",
            },
        ],
        name: "NodeCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "NodeRejected",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Paused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint64",
                name: "challengeIndex",
                type: "uint64",
            },
            {
                indexed: false,
                internalType: "address",
                name: "asserter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "challenger",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint64",
                name: "challengedNode",
                type: "uint64",
            },
        ],
        name: "RollupChallengeStarted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "machineHash",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
        ],
        name: "RollupInitialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "Unpaused",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "UpgradedSecondary",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "finalBalance",
                type: "uint256",
            },
        ],
        name: "UserStakeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "user",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "initialBalance",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "finalBalance",
                type: "uint256",
            },
        ],
        name: "UserWithdrawableFundsUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "VALIDATOR_AFK_BLOCKS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "_stakerMap",
        outputs: [
            {
                internalType: "uint256",
                name: "amountStaked",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "index",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "latestStakedNode",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "currentChallenge",
                type: "uint64",
            },
            {
                internalType: "bool",
                name: "isStaked",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakerAddress",
                type: "address",
            },
        ],
        name: "addToDeposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "amountStaked",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseStake",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "bridge",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "challengeManager",
        outputs: [
            {
                internalType: "contract IChallengeManager",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "challengeIndex",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "winningStaker",
                type: "address",
            },
            {
                internalType: "address",
                name: "losingStaker",
                type: "address",
            },
        ],
        name: "completeChallenge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "blockHash",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "sendRoot",
                type: "bytes32",
            },
        ],
        name: "confirmNextNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "confirmPeriodBlocks",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "countStakedZombies",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "countZombiesStakedOnChildren",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[2]",
                name: "stakers",
                type: "address[2]",
            },
            {
                internalType: "uint64[2]",
                name: "nodeNums",
                type: "uint64[2]",
            },
            {
                internalType: "enum MachineStatus[2]",
                name: "machineStatuses",
                type: "uint8[2]",
            },
            {
                components: [
                    {
                        internalType: "bytes32[2]",
                        name: "bytes32Vals",
                        type: "bytes32[2]",
                    },
                    {
                        internalType: "uint64[2]",
                        name: "u64Vals",
                        type: "uint64[2]",
                    },
                ],
                internalType: "struct GlobalState[2]",
                name: "globalStates",
                type: "tuple[2]",
            },
            {
                internalType: "uint64",
                name: "numBlocks",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "secondExecutionHash",
                type: "bytes32",
            },
            {
                internalType: "uint256[2]",
                name: "proposedBlocks",
                type: "uint256[2]",
            },
            {
                internalType: "bytes32[2]",
                name: "wasmModuleRoots",
                type: "bytes32[2]",
            },
        ],
        name: "createChallenge",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "currentChallenge",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "currentRequiredStake",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "extraChallengeTimeBlocks",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "firstUnresolvedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "getNode",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "stateHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "challengeHash",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "confirmData",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint64",
                        name: "prevNum",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "deadlineBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "noChildConfirmedBeforeBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "stakerCount",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "childStakerCount",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "firstChildBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "latestChildNumber",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "createdAtBlock",
                        type: "uint64",
                    },
                    {
                        internalType: "bytes32",
                        name: "nodeHash",
                        type: "bytes32",
                    },
                ],
                internalType: "struct Node",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
        ],
        name: "getNodeCreationBlockForLogLookup",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "getStaker",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amountStaked",
                        type: "uint256",
                    },
                    {
                        internalType: "uint64",
                        name: "index",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "latestStakedNode",
                        type: "uint64",
                    },
                    {
                        internalType: "uint64",
                        name: "currentChallenge",
                        type: "uint64",
                    },
                    {
                        internalType: "bool",
                        name: "isStaked",
                        type: "bool",
                    },
                ],
                internalType: "struct IRollupCore.Staker",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "stakerNum",
                type: "uint64",
            },
        ],
        name: "getStakerAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "inbox",
        outputs: [
            {
                internalType: "contract IInboxBase",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeToken",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isERC20Enabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isStaked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isStakedOnLatestConfirmed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isValidator",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "isZombie",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastStakeBlock",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestConfirmed",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "latestNodeCreated",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "latestStakedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "loserStakeEscrow",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minimumAssertionPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "nodeHash",
                type: "bytes32",
            },
        ],
        name: "newStakeOnExistingNode",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "expectedNodeHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "prevNodeInboxMaxCount",
                type: "uint256",
            },
        ],
        name: "newStakeOnNewNode",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                internalType: "address",
                name: "staker",
                type: "address",
            },
        ],
        name: "nodeHasStaker",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "outbox",
        outputs: [
            {
                internalType: "contract IOutbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "target",
                type: "uint256",
            },
        ],
        name: "reduceDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakerAddress",
                type: "address",
            },
        ],
        name: "rejectNextNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "startIndex",
                type: "uint256",
            },
        ],
        name: "removeOldZombies",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeWhitelistAfterFork",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "removeWhitelistAfterValidatorAfk",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "zombieNum",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "maxNodes",
                type: "uint256",
            },
        ],
        name: "removeZombie",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "nodeNum",
                type: "uint256",
            },
        ],
        name: "requireUnresolved",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "requireUnresolvedExists",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "blockNumber",
                type: "uint256",
            },
            {
                internalType: "uint64",
                name: "firstUnresolvedNodeNum",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "latestCreatedNode",
                type: "uint64",
            },
        ],
        name: "requiredStake",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "stakerAddress",
                type: "address",
            },
        ],
        name: "returnOldDeposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "rollupDeploymentBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rollupEventInbox",
        outputs: [
            {
                internalType: "contract IRollupEventInbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sequencerInbox",
        outputs: [
            {
                internalType: "contract ISequencerInbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint64",
                name: "nodeNum",
                type: "uint64",
            },
            {
                internalType: "bytes32",
                name: "nodeHash",
                type: "bytes32",
            },
        ],
        name: "stakeOnExistingNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "beforeState",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                components: [
                                    {
                                        internalType: "bytes32[2]",
                                        name: "bytes32Vals",
                                        type: "bytes32[2]",
                                    },
                                    {
                                        internalType: "uint64[2]",
                                        name: "u64Vals",
                                        type: "uint64[2]",
                                    },
                                ],
                                internalType: "struct GlobalState",
                                name: "globalState",
                                type: "tuple",
                            },
                            {
                                internalType: "enum MachineStatus",
                                name: "machineStatus",
                                type: "uint8",
                            },
                        ],
                        internalType: "struct ExecutionState",
                        name: "afterState",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "numBlocks",
                        type: "uint64",
                    },
                ],
                internalType: "struct Assertion",
                name: "assertion",
                type: "tuple",
            },
            {
                internalType: "bytes32",
                name: "expectedNodeHash",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "prevNodeInboxMaxCount",
                type: "uint256",
            },
        ],
        name: "stakeOnNewNode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "stakeToken",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "stakerCount",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalWithdrawableFunds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorUtils",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorWalletCreator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "validatorWhitelistDisabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wasmModuleRoot",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "withdrawStakerFunds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "withdrawableFunds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "zombieNum",
                type: "uint256",
            },
        ],
        name: "zombieAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "zombieCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "zombieNum",
                type: "uint256",
            },
        ],
        name: "zombieLatestStakedNode",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class RollupUserLogic__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "RollupUserLogic";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.RollupUserLogic__factory = RollupUserLogic__factory;
RollupUserLogic__factory.bytecode = _bytecode;
RollupUserLogic__factory.abi = _abi;
